/**
 * Placeholder shown while a lazily loaded page's code downloads (see App.tsx route splitting).
 * Kept deliberately light: it renders inside the dashboard shell or on its own for public pages.
 */
import { Skeleton } from '@components/common/Skeleton';

import './RouteFallback.css';

export function RouteFallback() {
  return (
    <div className="bhg-route-fallback" role="status" aria-live="polite" aria-label="Loading page">
      <Skeleton variant="line" lineSize="lg" width="40%" />
      <Skeleton variant="line" width="90%" />
      <Skeleton variant="line" width="75%" />
    </div>
  );
}
